<template>
  <v-card>
    <v-card-title class="calc_params" style="padding: 5px 20px ">
      <v-row no-gutters>
        <v-col cols="4" style="display: flex;align-items: center; justify-content: start;">
          <div class="colorblue" style="display: inline-block;">Параметры расчета гарантии</div>
          <v-icon
            color="green darken-2"
            v-if="!showDopParams"
            @click="showDopParams = !showDopParams"
          >
            mdi-chevron-down
          </v-icon>
          <v-icon
            color="green darken-2"
            v-if="showDopParams"
            @click="showDopParams = !showDopParams"
          >
            mdi-chevron-up
          </v-icon>
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="3" style="display: flex;padding-top: 10px;justify-content: end;">
          <v-btn
            class="mb-2"
            color="orange"
            @click="$emit('CloseDialog')"
            outlined
            >Изменить параметры</v-btn
          >
        </v-col>
      </v-row>
    </v-card-title>
    <transition>
      <v-card v-if="showDopParams">
        <div class="borderedStyle pt-2 pb-2 pl-2">
          <v-row no-gutters class="calcParam">
            <v-col md="6">
              <v-simple-table class="paramsTable">
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <td width="40%">Сумма БГ</td>
                      <td>
                        {{ addCommas(calc.summ) }}
                        <template v-if="calc.trebUvelSumm">
                          <v-tooltip right>
                            <template v-slot:activator="{ on }">
                              <v-icon right color="primary" dark v-on="on"
                                >info</v-icon
                              >
                            </template>
                            <span>
                              Сумма БГ увеличина
                              <br />в 1.5 раза
                            </span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <td width="40%">Срок действия БГ</td>
                      <td>
                        c {{ calc.date }} по {{ calc.date2 }} ({{ calc.days }}
                        дней)
                      </td>
                    </tr>
                    <tr>
                      <td width="40%">Вид закупки</td>
                      <td>{{ getPurchaseById }}</td>
                    </tr>
                    <tr>
                      <td width="40%">Вид гарантии</td>
                      <td>{{ getQuaranteesById }}</td>
                    </tr>

                    <tr
                      v-if="
                        calc.gar_polz_zaksVal !== null &&
                        calc.gar_polz_zaksVal !== undefined
                      "
                    >
                      <td width="40%">Гарантия в пользу заказчика</td>
                      <td>{{ getGarPolzZakActual().name }}</td>
                    </tr>
                    <tr
                      v-if="
                        calc.your_situationsVal !== null &&
                        calc.your_situationsVal !== undefined
                      "
                    >
                      <td width="40%">Ситуация у клиента</td>
                      <td>{{ getClientSituation() }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col md="6">
              <div class="centertop">
                <!-- <v-switch
                    class="selects"
                    false-value="Нет"
                    true-value="Да"
                    v-model="calc.isBS"
                    readonly
                  >
                    <template v-if="calc.isBS == 'Да'" v-slot:label>
                      <span class="activeSwitch"
                        >Условие о бесспорном списании</span
                      >
                    </template>
                    <template v-else v-slot:label
                      >Условие о бесспорном списании</template
                    >
                  </v-switch> -->
                <v-switch
                  class="selects"
                  false-value="Нет"
                  true-value="Да"
                  v-model="calc.isGarFormZak"
                  readonly
                >
                  <template v-if="calc.isGarFormZak == 'Да'" v-slot:label>
                    <span class="activeSwitch"
                      >Гарантия по форме заказчика</span
                    >
                  </template>
                  <template v-else v-slot:label
                    >Гарантия по форме заказчика</template
                  >
                </v-switch>
                <v-switch
                  class="selects"
                  false-value="Нет"
                  true-value="Да"
                  v-model="calc.isAvans"
                  readonly
                >
                  <template v-if="calc.isAvans == 'Да'" v-slot:label>
                    <span class="activeSwitch">Наличие аванса</span>
                  </template>
                  <template v-else v-slot:label>Наличие аванса</template>
                </v-switch>

                <v-switch
                  class="selects"
                  false-value="Нет"
                  true-value="Да"
                  v-model="calc.isPaper"
                  readonly
                >
                  <template v-if="calc.isPaper == 'Да'" v-slot:label>
                    <span class="activeSwitch"
                      >Требуется оригинал гарантии на бумаге</span
                    >
                  </template>
                  <template v-else v-slot:label
                    >Требуется оригинал гарантии на бумаге</template
                  >
                </v-switch>
              </div>
            </v-col>
          </v-row>
        </div>
        <div v-if="protocolInfo">
          <div v-if="winnerInfo">
            <v-card-title>
              <v-row>
                <v-col cols="2">
                  <div class="colorblue">О победителе</div>
                </v-col>
                <v-col cols="1" style="display: flex; align-items: center">
                  <v-icon
                    color="green darken-2"
                    v-if="!showDopWinner"
                    @click="showDopWinner = !showDopWinner"
                  >
                    mdi-chevron-down
                  </v-icon>
                  <v-icon
                    color="green darken-2"
                    v-if="showDopWinner"
                    @click="showDopWinner = !showDopWinner"
                  >
                    mdi-chevron-up
                  </v-icon>
                </v-col>
              </v-row>
            </v-card-title>
            <transition name="fade">
              <v-card-text v-if="showDopWinner">
                <div class="borderedStyle pt-2 pb-2 pl-2">
                  <v-row>
                    <v-col>
                      {{
                        winnerInfo.main &&
                        winnerInfo.main.data &&
                        winnerInfo.main.data.short_with_opf
                          ? winnerInfo.main.data.short_with_opf
                          : winnerInfo.main.value
                      }}, ИНН: {{ winnerInfo.inn }}
                    </v-col>
                  </v-row>
                  <v-row
                    v-if="
                      winnerInfo.main &&
                      winnerInfo.main.data &&
                      winnerInfo.main.data.state &&
                      winnerInfo.main.data.state.registration_date
                    "
                  >
                    <v-col cols="6">
                      Зарегестрирован:
                      {{
                        moment
                          .unix(
                            (
                              winnerInfo.main.data.state.registration_date /
                              1000
                            ).toFixed(0)
                          )
                          .format("DD.MM.YYYY")
                      }}
                    </v-col>
                    <v-col cols="6">
                      За 3 года побед на сумму
                      {{ Number(getWinsSumm()).toLocaleString("ru") }} ₽
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </transition>
          </div>

          <v-card-title>
            <v-row>
              <v-col cols="2">
                <div class="colorblue">О Закупке</div>
              </v-col>
              <v-col cols="1" style="display: flex; align-items: center">
                <v-icon
                  color="green darken-2"
                  v-if="!showDopNotifyNumber"
                  @click="showDopNotifyNumber = !showDopNotifyNumber"
                >
                  mdi-chevron-down
                </v-icon>
                <v-icon
                  color="green darken-2"
                  v-if="showDopNotifyNumber"
                  @click="showDopNotifyNumber = !showDopNotifyNumber"
                >
                  mdi-chevron-up
                </v-icon>
              </v-col>
            </v-row>
          </v-card-title>
          <transition name="fade">
            <v-card-text v-if="showDopNotifyNumber">
              <div class="borderedStyle pt-2 pb-2 pl-2">
                <v-row>
                  <v-col>
                    № {{ protocolInfo.notificationNumber }}
                    <span
                      v-if="
                        protocolInfo.purchase && protocolInfo.purchase.isSmp
                      "
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <span v-on="on" style="color: tomato">{{
                            protocolInfo.purchase.isSmp && "для СМП"
                          }}</span>
                        </template>
                        <span>Закупка для СМП</span>
                      </v-tooltip>
                    </span>
                  </v-col>
                  <v-col v-if="protocolInfo.purchaseObjectInfo">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{
                          protocolInfo.purchaseObjectInfo
                        }}</span>
                      </template>
                      <span>Предмет закупки</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    class="onHover"
                    v-if="
                      protocolInfo.purchase &&
                      protocolInfo.purchase.deliveryDate
                    "
                    @click="setDate(protocolInfo.purchase.deliveryDate)"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{
                          moment(protocolInfo.purchase.deliveryDate).format(
                            "DD.MM.YYYY"
                          )
                        }}</span>
                      </template>
                      <span>Срок выполнения обязательств</span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    v-if="
                      protocolInfo.purchase &&
                      protocolInfo.purchase.deliveryTerm
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{
                          protocolInfo.purchase.deliveryTerm
                        }}</span>
                      </template>
                      <span>Описание выполнения обязательств</span>
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="protocolInfo.deliveryTerm">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">{{ protocolInfo.deliveryTerm }}</span>
                      </template>
                      <span>Описание выполнения обязательств</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    v-if="
                      protocolInfo.price ||
                      (protocolInfo.purchase &&
                        protocolInfo.purchase.guaranteeing) ||
                      (protocolInfo.purchase &&
                        protocolInfo.purchase.maxprice) ||
                      (protocolInfo.purchase &&
                        protocolInfo.purchase.appguarantee) ||
                      (protocolInfo.purchase && protocolInfo.purchase.warranty)
                    "
                  >
                    <v-tooltip bottom v-if="protocolInfo.price">
                      <template v-slot:activator="{ on }">
                        <span
                          class="onHover"
                          v-on="on"
                          @click="changeSumm(protocolInfo.price)"
                        >
                          {{ addCommas(protocolInfo.price) }}
                        </span>
                      </template>
                      <span>Начальная цена контракта</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="protocolInfo.guaranteeing">
                      <template v-slot:activator="{ on }">
                        <span
                          class="onHover"
                          v-on="on"
                          @click="changeSumm(protocolInfo.guaranteeing)"
                        >
                          / {{ addCommas(protocolInfo.guaranteeing) }}
                        </span>
                      </template>
                      <span>Размер обеспечения исполнения</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="protocolInfo.purchase.appguarantee">
                      <template v-slot:activator="{ on }">
                        <span
                          class="onHover"
                          v-on="on"
                          @click="
                            changeSumm(protocolInfo.purchase.appguarantee)
                          "
                        >
                          / {{ addCommas(protocolInfo.purchase.appguarantee) }}
                        </span>
                      </template>
                      <span>Размер обеспечения заявки</span>
                    </v-tooltip>

                    <v-tooltip bottom v-if="protocolInfo.purchase.lowPrice">
                      <template v-slot:activator="{ on }">
                        <span
                          class="onHover"
                          v-on="on"
                          @click="changeSumm(protocolInfo.purchase.lowPrice)"
                        >
                          / {{ addCommas(protocolInfo.purchase.lowPrice) }}
                        </span>
                      </template>
                      <span>Предложенная цена контракта</span>
                    </v-tooltip>

                    <v-tooltip
                      bottom
                      v-if="
                        protocolInfo.purchase &&
                        protocolInfo.purchase.warranty &&
                        protocolInfo.purchase.warranty.warranty_size
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <span class="onHover" v-on="on">
                          /
                          {{
                            addCommas(
                              protocolInfo.purchase.warranty.warranty_size
                            )
                          }}
                        </span>
                      </template>
                      <span>Гарантийные обязательства</span>
                    </v-tooltip>
                  </v-col>
                  <v-col
                    v-if="
                      protocolInfo.price &&
                      protocolInfo.purchase &&
                      protocolInfo.purchase.lowPrice &&
                      protocolInfo.purchase.isSmp
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <span v-on="on">
                          {{
                            protocolInfo.price -
                              (protocolInfo.purchase.lowPrice /
                                protocolInfo.price) *
                                100 >
                            0
                              ? `${smpPrice} %`
                              : ""
                          }}
                        </span>
                      </template>
                      <span>Обеспечение исполнения для СМП</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </transition>
        </div>
      </v-card>
    </transition>
  </v-card>
</template>
<script>
import moment from "moment";
export default {
  name: "CalcResultParams",
  components: {},
  data: () => ({
    moment,
    showDopParams: false,
    showDopWinner: false,
    showDopNotifyNumber: false,
  }),
  props: {
    calc: {},
  },
  methods: {
    smpPrice() {
      const price =
        this.protocolInfo.price && Number(parseInt(this.protocolInfo.price));
      const lowPrice =
        this.protocolInfo.purchase.lowPrice &&
        Number(parseInt(this.protocolInfo.purchase.lowPrice));
      return this.addCommas((price - (lowPrice / price) * 100).toFixed(2));
    },
    getWinsSumm() {
      const wins = this.DeepCopy(this.winnerInfo.wins);
      const result = new Array();
      for (const win of wins) {
        result.push(win.totalsum);
      }
      return result.reduce((a, b) => parseInt(a) + parseInt(b));
    },
  },
  computed: {
    getPurchaseById() {
      const purchase = this.$store.getters.getPurchaseById(
        this.$store.getters.calc.purchasesVal
      );
      if (purchase.length) {
        return purchase[0].name;
      } else {
        return "-";
      }
    },
    getQuaranteesById() {
      const quarantee = this.$store.getters.getQuaranteesById(
        this.$store.getters.calc.quaranteesVal
      );
      if (quarantee.length) {
        return quarantee[0].name;
      } else {
        return "-";
      }
    },
    protocolInfo() {
      return this.$store.getters.protocol_info;
    },
    winnerInfo() {
      return this.$store.getters.winner_info;
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style lang="sass" scoped>
.colorblue
  font-size: 1.075rem
</style>
